import React, { ReactElement, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";

interface Props {
    shouldShow: boolean;
    title?: string | ReactElement | (string | ReactElement)[];
    variant?: string;
    children: ReactElement | string;
    seconds?: number;
    onClose?: () => void;
    className?: string;
    alertClassName?: string;
    titleClassName?: string;
}

const DEFAULT_SECONDS = 5;
export default function TimedMessage({
    children, seconds, onClose, variant, title, shouldShow, className, alertClassName, titleClassName,
}: Props): ReactElement | null {
    const [timeleft, setTimeLeft] = useState(seconds ?? DEFAULT_SECONDS);

    useEffect(() => {
        if (seconds) {
            setTimeLeft(seconds);
        }
    }, [seconds]);

    useEffect(() => {
        if (shouldShow) {
            setTimeLeft(seconds ?? DEFAULT_SECONDS);
        } else if (shouldShow === false) {
            setTimeLeft(0);
        }
    }, [shouldShow]);

    const handleClose = () => {
        setTimeLeft(0);
        onClose?.();
    };

    useEffect(() => {
        if (timeleft === 0) {
            onClose?.();
        }
        setTimeout(() => {
            setTimeLeft(current => Math.max(current - 1, 0));
        }, 1000);
    }, [timeleft]);

    if (timeleft <= 0) {
        return null;
    }

    return (
        <div className={`fixed-top m-auto w-50 mt-4 ${className}`}>
            <Alert
                onClose={handleClose}
                variant={variant}
                className={`d-flex justify-content-between ${alertClassName}`}
            >
                <div className="w-100">
                    {title && <h5 className={`mb-2 ${titleClassName}`}>{title}</h5>}
                    {children}
                </div>
                <button type="button" className="btn-close btn-sm" aria-label="Close" onClick={handleClose} />

            </Alert>
        </div>
    );
}

TimedMessage.defaultProps = {
    seconds: 5,
    onClose: undefined,
    variant: "success",
    title: undefined,
    className: "",
    alertClassName: "",
    titleClassName: "",
};
